import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Vendor} from './vendor';

@Injectable()
export class VendorService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all vendors which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.vendorURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(vendor : Vendor) {
    console.log('Push vendor to insert method of service.');
    vendor.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(vendor));
    return this.http.post(this.config.vendorURL+"new", JSON.stringify(vendor), {headers: this.headers});
  }

  public update(vendor : Vendor) {
    console.log('Push vendor to insert method of service.');
    vendor.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(vendor));
    return this.http.put(this.config.vendorURL+"id/"+vendor.id, JSON.stringify(vendor), {headers: this.headers});
  }

  public qryVendor(id : number) {
    return this.http.post(this.config.vendorURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete vendor '+ id);
    return this.http.post(this.config.vendorURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/vendor/vendor.service.ts